import React, { useMemo, useRef, useEffect, useState } from "react";
import ModuleLight from "./moduleLight";
import SingleLight from "./singleLight";

export default function LightbarDrawing({ lightData, currentZoneData, tooltipData }) {
  let lightbar = tooltipData.replace(/<br \/>/gi, "<br>");
  lightbar = lightbar.replace(/<br\/>/gi, "<br>");
  lightbar = lightbar.split("<br>");

  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  // calculate bounds
  const { maxX, maxY } = useMemo(
    () => ({
      maxX: Math.max(...lightData.map((l) => +l.left + +l.width)),
      maxY: Math.max(...lightData.map((l) => +l.top + +l.height)),
    }),
    [lightData]
  );

  // calculate scale to fit container
  useEffect(() => {
    const resize = () => {
      if (!containerRef.current) return;
      const { offsetWidth, offsetHeight } = containerRef.current;
      const scaleX = offsetWidth / maxX;
      const scaleY = offsetHeight / maxY;

      // maintain aspect ratio
      const newScale = Math.min(scaleX, scaleY) * 0.65;
      if (lightData.length <= 8 && newScale > 15) {
        setScale(15);
        return;
      }
      setScale(newScale);
    };
    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [maxX, maxY]);

  const moduleOutputs =
    lightData.filter((light) => light.moduleOutputs && Array.isArray(light.moduleOutputs)).length > 0;

  const sortedLightData = lightData
    .sort((a, b) => +a.lightheadPosition - +b.lightheadPosition)
    .filter((light) => light.angle !== "90" && light.angle !== "270");

  const topLightheads = sortedLightData.filter((lighthead) => lighthead.top === "0");

  return (
    <>
      <div className="lightbar-description">
        {lightbar?.map((data, i) => (
          <div className="text-white mt-10">
            {data}
            {i === 0 && (
              <span className="zone-text">
                , ZONE-
                {currentZoneData.zone}
              </span>
            )}
          </div>
        ))}
      </div>
      <div
        className="canvas-position mb-5"
        ref={containerRef}
        style={{
          padding: "1.5rem 0 2rem 0", // spacing inside
        }}
      >
        {/* Scaled Canvas, In case of Freedom V data needs recalculation */}
        <div
          style={{
            position: "relative",
            width: maxX * scale - (moduleOutputs ? 40 : 0),
            minHeight: "90px",
            margin: "0 auto",
            display: "flex",
          }}
        >
          {lightData?.map((light, lightIndex) =>
            light.moduleOutputs ? (
              <ModuleLight
                key={light.outputId}
                light={light}
                lightData={lightData}
                topLightheads={topLightheads}
                scale={scale}
                lightIndex={lightIndex}
              />
            ) : (
              <SingleLight key={light?.outputId} light={light} scale={scale} lightIndex={lightIndex} />
            )
          )}
        </div>
      </div>
    </>
  );
}
